export const CHART_COLORS: string[] = [
    '#06CFD1',
    '#7D6CFF',
    '#99FFA9',
    '#F17809',
    '#000000',
    '#FECD01',
    '#FE4CCC',
  ];